import React, { useEffect } from 'react';

import {
    TemplateView,
    withTemplateCore,
    editionLevels,
} from '@sunwisesoftware/racking-template-core';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';

import { getCurrentLanguage } from 'common/utils/helpers/multiregion';

import * as actions from './actions';
import * as selectors from './selectors';

const Container = ({
    initialize,
    initTemplate,
    isFetchingProposalContent,
    match,
}) => {
    const contentId = get(match, 'params.uid', null);

    useEffect(() => {
        if (contentId) {
            initialize({
                contentId,
                initTemplate,
            });
        }
    }, [contentId]);

    if (!contentId || isFetchingProposalContent) return null;

    return (
        <TemplateView
            editionLevel={editionLevels.NO_EDITION_MODE}
            pageDesignDisabled
        />
    );
};

Container.propTypes = {
    initialize: PropTypes.func,
    initTemplate: PropTypes.func,
    isFetchingProposalContent: PropTypes.bool,
    match: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
    isFetchingProposalContent: selectors.getIsFetchingProposalContent,
});

const mapDispatchToProps = (dispatch) => ({
    initialize: (values) => dispatch(actions.initialize(values)),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withTemplateCore(() => ({
        baseUrl: import.meta.env.VITE_API_URL,
        editionMode: editionLevels.NO_EDITION_MODE,
        froalaLicenseKey: import.meta.env.VITE_FROALA_LICENSE,
        googleApiKey: import.meta.env.VITE_GOOGLE_MAPS_KEY,
        language: getCurrentLanguage(),
    })),
)(Container);
